import { extendTheme } from "@chakra-ui/react";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import UserProvider from "./contexts/UserContext";
import WalletProvider from "./contexts/WalletContext";
import ContractProvider from "./contexts/BackupContractContext";
import WalletModalProvider from "./contexts/WalletModalContext";
import "@fontsource/dm-sans/400.css";
import { ChakraProvider } from "@chakra-ui/react";
import { StepsTheme } from "chakra-ui-steps";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

const CustomSteps = {
  ...StepsTheme,
  baseStyle: (props: any) => {
    return {
      ...StepsTheme.baseStyle(props),
      stepIconContainer: {
        ...StepsTheme.baseStyle(props).stepIconContainer,
        flexShrink: 0,
      },
      label: {
        ...StepsTheme.baseStyle(props).label,
        fontSize: "sm",
      },
    };
  },
};

const theme = extendTheme({
  components: {
    Steps: CustomSteps,
  },
  fonts: {
    heading: "'DM Sans', sans-serif",
    body: "'DM Sans', sans-serif",
  },
});

root.render(
  <React.StrictMode>
    <UserProvider>
      <WalletProvider>
        <ContractProvider>
          <WalletModalProvider>
            <ChakraProvider theme={theme}>
              <App />
            </ChakraProvider>
          </WalletModalProvider>
        </ContractProvider>
      </WalletProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
